export default __webpack_public_path__ + "static/media/M32.133ad3f0.svg";